import React, { useState, useEffect, useRef } from "react";
import { Star, ThumbsUp } from "lucide-react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const PROFILE_IMAGES = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
];

const PRODUCT_REVIEW_IMAGES = {
  industrial: ["https://images.unsplash.com/photo-1581090464777-f3220bbe1b8b?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1535295972055-1c762f4483e5?w=400&h=300&fit=crop"],
  auto: ["https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1507133750040-4a8f57021571?w=400&h=300&fit=crop"],
  general: ["https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop"],
  beauty: ["https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=400&h=300&fit=crop"],
  tech: ["https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=300&fit=crop"],
  home: ["https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=400&h=300&fit=crop"],
  kitchen: ["https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=400&h=300&fit=crop"],
  fitness: ["https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=300&fit=crop"],
  garden: ["https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1585336261022-680e295ce3fe?w=400&h=300&fit=crop", "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop"],
};

const REVIEWS_BY_CATEGORY = {
  industrial: [
    { name: "Mihai D.", location: "Brașov", rating: 5, text: "Am lipit o țeavă crăpată de calorifer, ține de 3 luni perfect. Mai bun decât sudura, recomand!", profileIndex: 0, hasProductImage: true, daysAgo: 3, likes: 24 },
    { name: "Vasile P.", location: "Iași", rating: 5, text: "Am încercat să rup ce am lipit. Imposibil. 1420 kg e real, băieți. Cel mai bun adeziv din viața mea.", profileIndex: 1, hasProductImage: true, daysAgo: 7, likes: 18 },
    { name: "Andrei C.", location: "Cluj", rating: 5, text: "Mecanic auto aici. Folosesc metal.FIX la atelier de luni de zile. Calitate superioară, clienții sunt mulțumiți.", profileIndex: 2, hasProductImage: true, daysAgo: 12, likes: 31 },
  ],
  auto: [
    { name: "Bogdan S.", location: "București", rating: 5, text: "Am avut o zgârietură urâtă pe capotă. În 30 secunde a dispărut complet. Pare magic, dar funcționează!", profileIndex: 3, hasProductImage: true, daysAgo: 2, likes: 42, profileImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face", productImage: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400&h=300&fit=crop" },
    { name: "Ana M.", location: "Timișoara", rating: 5, text: "Mi-am salvat banii de la service. Funcționează pe culoarea mea (roșu metalizat) perfect. Worth every leu.", profileIndex: 4, hasProductImage: true, daysAgo: 5, likes: 28, profileImage: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face", productImage: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400&h=300&fit=crop" },
    { name: "Răzvan I.", location: "Constanța", rating: 5, text: "Comandat de probă, am rămas șocat. Trei zgârieturi eliminate în 2 minute. Rezistă și după spălare auto.", profileIndex: 5, hasProductImage: true, daysAgo: 9, likes: 35, profileImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face", productImage: "https://images.unsplash.com/photo-1507133750040-4a8f57021571?w=400&h=300&fit=crop" },
    { name: "Marius P.", location: "Cluj", rating: 5, text: "Am folosit pixul magic pe faruri și bara față. Rezultat incredibil! Economie de 500 lei la service.", profileIndex: 6, hasProductImage: true, daysAgo: 4, likes: 31, profileImage: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face", productImage: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400&h=300&fit=crop" },
    { name: "Elena D.", location: "Brașov", rating: 5, text: "Soțul meu e pasionat de mașini. A zis că e cel mai bun produs pe care l-a cumpărat. Recomand!", profileIndex: 7, hasProductImage: true, daysAgo: 7, likes: 19, profileImage: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face", productImage: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400&h=300&fit=crop" },
  ],
  general: [
    { name: "Andreea P.", location: "București", rating: 5, text: "Comandă rapidă, colet primit în 2 zile. Plata la livrare super convenabilă.", profileIndex: 6, hasProductImage: false, daysAgo: 4, likes: 12 },
    { name: "Mihai T.", location: "Cluj", rating: 5, text: "Calitate peste așteptări. Am revenit pentru o a doua comandă.", profileIndex: 7, hasProductImage: false, daysAgo: 8, likes: 9 },
    { name: "Ioana R.", location: "Iași", rating: 5, text: "Recomand. Produsele exact ca în descriere, livrare corectă.", profileIndex: 8, hasProductImage: false, daysAgo: 14, likes: 15 },
  ],
  beauty: [
    { name: "Elena S.", location: "București", rating: 5, text: "Pielea mea arată incredibil după 2 săptămâni. Toată lumea mă întreabă ce tratament folosesc!", profileIndex: 0, hasProductImage: true, daysAgo: 3, likes: 22 },
    { name: "Maria C.", location: "Cluj", rating: 5, text: "În sfârșit un produs care chiar funcționează. Textură ușoară, se absoarbe repede.", profileIndex: 1, hasProductImage: true, daysAgo: 6, likes: 17 },
    { name: "Laura B.", location: "Timișoara", rating: 5, text: "Am pielea sensibilă și acesta e singurul produs care nu m-a iritat. Recomand cu încredere!", profileIndex: 2, hasProductImage: true, daysAgo: 11, likes: 25 },
  ],
  tech: [
    { name: "Alex P.", location: "București", rating: 5, text: "Cel mai bun gadget pe care l-am cumpărat anul ăsta. Funcționează exact cum promite.", profileIndex: 3, hasProductImage: true, daysAgo: 2, likes: 38 },
    { name: "Cristi M.", location: "Iași", rating: 5, text: "Calitate premium la preț corect. Livrare rapidă, ambalaj perfect.", profileIndex: 4, hasProductImage: true, daysAgo: 7, likes: 19 },
    { name: "Dan S.", location: "Cluj", rating: 5, text: "L-am testat o săptămână întreagă. Battery life incredibil, performanță top.", profileIndex: 5, hasProductImage: true, daysAgo: 10, likes: 27 },
  ],
  home: [
    { name: "Adriana V.", location: "București", rating: 5, text: "Mi-a transformat complet livingul. Design elegant, calitate superioară.", profileIndex: 6, hasProductImage: true, daysAgo: 4, likes: 33 },
    { name: "Simona R.", location: "Constanța", rating: 5, text: "Ușor de montat, arată exact ca în poze. Foarte mulțumită!", profileIndex: 7, hasProductImage: true, daysAgo: 8, likes: 14 },
    { name: "Monica L.", location: "Brașov", rating: 5, text: "Raport calitate-preț imbatabil. Am mai comandat încă două pentru cadou.", profileIndex: 8, hasProductImage: true, daysAgo: 13, likes: 21 },
  ],
  kitchen: [
    { name: "Carmen D.", location: "București", rating: 5, text: "Gătesc zilnic cu el și economisesc atât de mult time. Cel mai bun investment pentru bucătărie!", profileIndex: 0, hasProductImage: true, daysAgo: 5, likes: 29 },
    { name: "Ioana M.", location: "Cluj", rating: 5, text: "Se curăță ușor, nu se lipește nimic de el. Recomand cu drag!", profileIndex: 1, hasProductImage: true, daysAgo: 9, likes: 16 },
    { name: "Gabriela P.", location: "Timișoara", rating: 5, text: "Soțul meu e impresionat de cât de repede gătesc acum. Produs fantastic!", profileIndex: 2, hasProductImage: true, daysAgo: 12, likes: 23 },
  ],
  fitness: [
    { name: "Robert K.", location: "București", rating: 5, text: "Folosesc produsul de 3 săptămâni și rezultatele sunt vizibile. Mușchii se definesc frumos.", profileIndex: 3, hasProductImage: true, daysAgo: 3, likes: 41 },
    { name: "Andrei F.", location: "Cluj", rating: 5, text: "Calitate profesională la preț de amator. Îl recomand tuturor din sală.", profileIndex: 4, hasProductImage: true, daysAgo: 6, likes: 18 },
    { name: "Marius T.", location: "Iași", rating: 5, text: "Rezistent, ușor de folosit, perfect și pentru acasă. Worth every leu!", profileIndex: 5, hasProductImage: true, daysAgo: 11, likes: 26 },
  ],
  garden: [
    { name: "Ion G.", location: "Brașov", rating: 5, text: "Grădina mea arată ca niciodată. Produsul face exact ce promite.", profileIndex: 6, hasProductImage: true, daysAgo: 4, likes: 32 },
    { name: "Victor S.", location: "Cluj", rating: 5, text: "Ușor de aplicat, rezultate imediate. Vecinii mă întreabă ce secret am.", profileIndex: 7, hasProductImage: true, daysAgo: 8, likes: 19 },
    { name: "Gheorghe M.", location: "Timișoara", rating: 5, text: "După o lună de utilizare, plantele mele sunt sănătoase și viguroase.", profileIndex: 8, hasProductImage: true, daysAgo: 14, likes: 28 },
  ],
};

const Stars = ({ count = 5, size = "sm", color = "text-brand-500" }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className={`w-${size === "sm" ? "3.5" : "4"} h-${size === "sm" ? "3.5" : "4"} fill-current ${color}`} />
    ))}
  </div>
);

const ReviewCard = ({ review: r, index: i, accentClass, productImages, profileImages }) => {
  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), i * 80);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, [i]);

  return (
    <div
      ref={cardRef}
      className="bg-white border border-ink-200 rounded-xl p-5 hover:border-ink-300 hover:shadow-sm transition-all duration-500 ease-out"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transitionDelay: `${i * 80}ms`
      }}
      data-testid={`review-card-${i}`}
    >
      <div className="flex items-center gap-3 mb-3">
        <img src={r.profileImage || profileImages[r.profileIndex % profileImages.length]} alt={r.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" />
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-ink-900">{r.name}</span>
          </div>
          <div className="text-xs text-ink-500">{r.location} · <span className="text-green-600 font-medium">Cumpărător verificat</span> · {r.daysAgo}z</div>
        </div>
      </div>
      <div className="mb-3"><Stars count={r.rating} color={accentClass} /></div>
      <p className="text-sm text-ink-700 leading-relaxed mb-4">"{r.text}"</p>
      {r.hasProductImage && (
        <div className="mb-4 rounded-lg overflow-hidden border border-ink-100">
          <img src={r.productImage || productImages[i % productImages.length]} alt={`Recenzie ${r.name}`} className="w-full h-40 object-cover" />
        </div>
      )}
      <div className="flex items-center justify-between pt-3 border-t border-ink-100">
        <div className="flex items-center gap-1.5 text-xs text-ink-500">
          <div className="flex -space-x-1.5">
            <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-500 text-[8px]">👍</span>
            <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-500 text-[8px]">❤️</span>
          </div>
          <span className="ml-1">{r.likes}</span>
        </div>
        <div className="flex items-center gap-3">
          <button className="flex items-center gap-1 text-xs text-ink-500 hover:text-ink-700 transition-colors font-medium">
            <ThumbsUp className="w-3.5 h-3.5" /><span>Like</span>
          </button>
          <button className="text-xs text-ink-500 hover:text-ink-700 transition-colors font-medium">Comentează</button>
          <button className="text-xs text-ink-500 hover:text-ink-700 transition-colors font-medium">Distribuie</button>
        </div>
      </div>
    </div>
  );
};

export const Reviews = ({ rating = 4.8, count = 247, category = "general", accentClass = "text-brand-500", productName = "", productId = "" }) => {
  const [reviews, setReviews] = useState([]);
  const productImages = PRODUCT_REVIEW_IMAGES[category] || PRODUCT_REVIEW_IMAGES.general;
  
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const reviewsRef = collection(db, "reviews");
        if (productId) {
          const q = query(reviewsRef, where("productId", "==", productId));
          const querySnapshot = await getDocs(q);
          const reviewsList = [];
          querySnapshot.forEach((doc) => reviewsList.push({ id: doc.id, ...doc.data() }));
          reviewsList.sort((a, b) => {
            if (a.created_at && b.created_at) return b.created_at.seconds - a.created_at.seconds;
            return (a.daysAgo || 0) - (b.daysAgo || 0);
          });
          if (reviewsList.length === 0) {
            setReviews(REVIEWS_BY_CATEGORY[category] || REVIEWS_BY_CATEGORY.general);
          } else {
            setReviews(reviewsList);
          }
        } else {
          setReviews(REVIEWS_BY_CATEGORY[category] || REVIEWS_BY_CATEGORY.general);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews(REVIEWS_BY_CATEGORY[category] || REVIEWS_BY_CATEGORY.general);
      }
    };
    fetchReviews();
  }, [category, productId]);
  
  const title = productName ? `De ce aleg clientii noștri ${productName}` : "De ce aleg clientii noștri acest produs";

  return (
    <section className="py-16" data-testid="reviews-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <div className={`text-[11px] uppercase tracking-widest font-bold ${accentClass}`}>Recenzii clienți</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-ink-900 tracking-tight font-extrabold mt-2">{title}</h2>
        </div>
        <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-ink-50 border border-ink-200">
          <Stars color={accentClass} />
          <div>
            <div className="font-display text-2xl text-ink-900 font-extrabold leading-none">{rating.toFixed(1)}/5</div>
            <div className="text-xs text-ink-500 mt-0.5">{count.toLocaleString("ro-RO")} recenzii</div>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {reviews.map((r, i) => (
          <ReviewCard key={r.name || i} review={r} index={i} accentClass={accentClass} productImages={productImages} profileImages={PROFILE_IMAGES} />
        ))}
      </div>
    </section>
  );
};

export default Reviews;